import React from 'react'
import PropTypes from 'prop-types'
import flatMap from 'lodash/flatMap'

import { CashflowEvents } from '@containers/CashflowEvents'
import { ParticipantFilter } from '../ParticipantFilter'

export const JointCashflowEvents = ({ participantsQueries, config, jointCashflowEvents, jointCrudActions }) => {
  const [selectedParticipantId, setSelectedParticipantId] = React.useState('both')
  const selectedParticipantQuery = participantsQueries.find((participantQuery) => participantQuery.participant.id === selectedParticipantId)

  return (
    <>
      <CashflowEvents
        filter={(view) => (
          <ParticipantFilter
            showBoth
            filteredItemsName={'cashflow events'}
            view={view}
            participantsQueries={participantsQueries}
            selectedParticipantId={selectedParticipantId}
            setSelectedParticipantId={setSelectedParticipantId}
          />
        )}
        scenario={{
          id: selectedParticipantQuery?.scenario.data.baseScenario.id,
          expectedAge: selectedParticipantQuery?.scenario.data.baseScenario.expectedAge,
        }}
        cashflowEvents={
          selectedParticipantQuery
            ? selectedParticipantQuery.cashflowEvents.data
            : jointCashflowEvents
        }
        crudActions={selectedParticipantQuery?.cashflowEvents.actions || jointCrudActions}

        riskProfile={selectedParticipantQuery?.riskProfile.data}
        userDetails={{
          ...(selectedParticipantQuery?.participant || config.userDetails),
          clientCurrentAge: selectedParticipantQuery?.participant.currentAge || config.userDetails.clientCurrentAge
        }}
        assumptions={
          selectedParticipantQuery?.scenario.data.baseScenario.assumptions ||
          {
            inflation: Math.max(...participantsQueries.map((participantQuery) => participantQuery?.scenario?.data?.baseScenario?.assumptions?.inflation || 0.06)),
          }
        }

        participants={participantsQueries.map((participantQuery) => participantQuery.participant)}

      // NOTE: How necesary is this, and can we remove the liquidity checks
      // This is used to come up with an estimation if an expense event
      // has enough liquid capital to execute
      //editedProjectionData={forecast.data.baseScenario.forecast}
      />
    </>
  )
}

JointCashflowEvents.propTypes = {
  /** Array of participantsQueries */
  participantsQueries: PropTypes.array.isRequired,

  /** Config object */
  config: PropTypes.object.isRequired,

  /** Joint cashflow events data and crud actions */
  jointCashflowEvents: PropTypes.object.isRequired,
  jointCrudActions: PropTypes.object.isRequired,
}
